/* eslint func-names: 0 */
import { AppIntegrationsRepository, DevicesRepository } from 'common/repositories/index';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import { DevicesProcessor } from 'common/repositoryProcessors/index';
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';

angular.module('controllers').controller(
    'TrialCard',
    (
        $scope, $state,
        $stateParams, $window, $location,
        Util, LicenseRestService, DeployRestService,
    ) => {

        const queryParams = $location.search();

        $scope.showFirstScreen = true;
        $scope.loadingButton = false;
        $scope.trialDeploySuccess = false;
        $scope.appId = queryParams.appId || $stateParams.resourceId;

        const windowsDevices = DevicesRepository.getDevicesByOs('windows');

        $scope.hasWindowsDevice = windowsDevices.length > 0;

        $scope.app = AppIntegrationsRepository.getById($scope.appId);
        $scope.brandName = CWCONFIG.partnerConfig.name;
        $scope.product = AppIntegrationsRepository.getAppName('aps10');

        $scope.close = (newState) => {

            let currentState;
            if (!newState) {

                currentState = $state.current.name;
                newState = currentState.substr(0, currentState.indexOf('.ltb'));

            }
            $state.go(newState);

        };

        if ($stateParams.modal) {

            $stateParams.modal.result.then(() => {
            }, () => {

                $scope.close();

            });

        }

        $scope.init = () => {

            // redirect to dashboard if the service is not active
            if (!$scope.app) {

                $scope.close();
                return;

            }

            Mixpanel.send('ConnectWeb Modal Open ', {
                Modal: 'Prime Trial',
                Page: Util.getPageName(),
            });

        };

        /**
         * If the user has windows devices, deploy the Trial app on all the devices,
         * otherwise, download the kit
         */
        const deployTrialApp = (license) => {

            // deploy on all windows devices
            if ($scope.hasWindowsDevice) {

                windowsDevices.forEach((device) => {

                    const deploymentPayload = {
                        deviceId: device.id,
                        userId: Util.deepFind(device, 'relationships.user.data.id'),
                        appId: $scope.appId,
                    };

                    DeployRestService
                        .deployOnDevice(deploymentPayload)
                        .then(() => {})
                        .then(null, (e) => {

                            // 409 === Conflict
                            // An instance for this application already exists (pending) - ignore
                            if (e.status === 409) {

                                return;

                            }

                            Alert.error({
                                message: 'cw.modal.server-error.desc',
                                icon: {

                                    cssClasses: `icon-${Util.deepFind(device, 'attributes.type')}`,

                                },

                            });

                        });

                });

            } else {

                // no windows devices, download kit

                // check whether we can deploy the product on the current device
                const matchingOS =
                    DevicesProcessor.getDeployOSfor($scope.appId, window.deviceOs) || null;
                const hasMatchingOS = !!matchingOS;

                let stateName = $state.current.name;

                if (stateName.indexOf('.deploy') === -1) {

                    stateName += '.deploy';

                }

                $state.go(stateName, {
                    ltb: 'deploy',
                    resourceId: license.data.data.id,
                    appId: $scope.appId,
                    deviceId: 'new',
                    os: matchingOS,
                    autoInstall: hasMatchingOS,
                }, {
                    reload: false,
                });

            }

        };

        /**
         * Create a Trial license for the user.
         * If successful, deploy/download the trial app to the user
         */
        $scope.activateTrial = () => {

            $scope.loadingButton = true;

            Mixpanel.send('ConnectWeb Install Click', {
                Page: 'Trial Modal',
            });

            const licensePayload = {
                data: {
                    relationships: {
                        app: {
                            data: {
                                type: 'apps',
                                id: $scope.appId,
                            },
                        },
                    },
                },
                meta: {
                    cmp: CWCONFIG.features.trialModal.campaignId,
                },
            };

            LicenseRestService
                .create(licensePayload)
                .then((response) => {

                    $scope.loadingButton = false;
                    $scope.trialDeploySuccess = true;

                    deployTrialApp(response);

                })
                .then(null, (error) => {

                    $scope.loadingButton = false;

                    let errorCode = false;

                    if (error.data.errors && error.data.errors[0]) {

                        errorCode = error.data.errors[0].code;

                    }

                    $scope.activationStatus = 'serverError';
                    $scope.serverErrorTranslate = '';
                    $scope.loadingButton = false;

                    switch (errorCode) {

                    case '21224': // activation code was not found

                        Util.triggerAnimation('.error', 'animated shake');
                        $scope.serverErrorTranslate = 'cw.subscription.error.status_code_not_found';
                        break;

                    case '21223': // activation code invalid
                    case '21246': // code not found in database

                        Util.triggerAnimation('.error', 'animated shake');
                        $scope.serverErrorTranslate = 'cw.subscription.error.status_code_invalid';
                        break;

                    case '21236': // activation code already used

                        Util.triggerAnimation('.error', 'animated shake');
                        $scope.serverErrorTranslate = 'cw.subscription.error.status_code_already_used';
                        break;

                    case '21225': // activation code expired

                        Util.triggerAnimation('.error', 'animated shake');
                        $scope.serverErrorTranslate = 'cw.subscription.error.status_code_expired';
                        break;

                    case '21241': // maximum users for activation code

                        Util.triggerAnimation('.error', 'animated shake');
                        $scope.serverErrorTranslate = 'cw.subscription.error.max_users_reached';
                        break;

                    default:

                        Alert.error('cw.notification.system.error');
                        $scope.serverErrorTranslate = undefined;

                    }

                });

        };

        /**
         * Redirect to subscriptions page
         */
        $scope.goToSubscriptions = () => {

            $state.go('root.dashboard.subscriptions', {
                tab: 'plans',
            });

        };

        $scope.init();

    },
);



// WEBPACK FOOTER //
// ./scripts/controllers/modals/store-trial-card/trial-card.js